import { Directive, Input, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { isNullOrUndefined } from '@pineapplelab/util';
import { AuthService } from '@app/services/auth/auth.service';
import { PermissionEnum } from "../../enums/permissions.enum";

@Directive({
    selector: '[hasPermission]',
    standalone: false
})
export class HasPermissionsDirective {

	@Input('hasPermission') permission: PermissionEnum | PermissionEnum[] = null;
	@Input('hasPermissionInclusive') inclusive = true;

	// Tracks whether the embedded view is currently rendered, so `checkAccess()` only touches
	// the view container when access actually flips. Without this, callers that bind an inline
	// array/literal (e.g. `*hasPermission="[permissionEnum.CREATE_USER]"` — extremely common
	// across the app) pass a NEW reference on every change-detection check, which makes
	// `ngOnChanges` fire on every CD tick. The previous implementation called
	// `createEmbeddedView()` again on every one of those ticks WITHOUT clearing the existing
	// view first (only the false branch cleared), so the button/element was duplicated into
	// the DOM over and over, unboundedly, for as long as the page stayed open — a severe,
	// ever-growing perf/DOM-bloat bug, not just a one-off cost.
	private hasView = false;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		private authService: AuthService
	) { }

	ngOnInit() {
		this.viewContainerRef.clear();
		this.hasView = false;
		this.checkAccess();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (!isNullOrUndefined(changes.permission)) {
			this.checkAccess();
		}
	}

	checkAccess() {
		let access = false;
		if (!isNullOrUndefined(this.permission)) {
			access = this.authService.hasPermission( this.permission, this.inclusive );
		}
		if (access && !this.hasView) {
			this.viewContainerRef.createEmbeddedView( this.templateRef );
			this.hasView = true;
		} else if (!access && this.hasView) {
			this.viewContainerRef.clear();
			this.hasView = false;
		}
	}


}
